import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Loader from '../inc/Loader';
import Onboartop from './Onboardtop';
import { BsShieldLock } from "react-icons/bs";
import { BiLockAlt } from "react-icons/bi";
import { agtApiKey, getApiToken, emailValidate, passValidate,msgToast } from '../inc/myFunctions';
import API from "../inc/axios";
function Setpassword() {
    const navigate = useNavigate();
    const location = useLocation();
    const [inputType, setInputType] = useState('text');
    const pid = location.state;
    useEffect(() => {
        if (!emailValidate(pid.pid)) {
            navigate("/Forgetpass")
        }

    }, []);
    const [changePass, setchangePass] = useState({
        cust_otp_code: "",
        cust_login_pass: ""
    })
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const handleIpunt = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setInputType('password')
        setchangePass({ ...changePass, agt_api_key: agtApiKey(), cust_login_id: pid.pid, [name]: value })
        setErrors({ ...errors, [name]: '' })
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = {};
        if ((changePass.cust_otp_code).length != 6) {
            newErrors.cust_otp_code = "Please Enter Valid OTP CODE";
        }
        if (!passValidate(changePass.cust_login_pass)) {
            newErrors.cust_login_pass = "Password should contain at least one special character such as @#$%^&_, at least one number,minimum 7 characters length and should use a variation of upper and lower case letters.";
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            setLoading(true);
            const token = await getApiToken("Yes");
            const config = { headers: { Authorization: `Bearer ` + token } }
            const rs = await API.post('/customers/forgetpass.php?api_action=ChgPaswd', JSON.stringify(changePass), config);
            const msg = rs.data.status_msg;
            if (rs.status == 200 && rs.data.status_code == 1000) {
                if (msg == "SUCCESSFULL") {
                    msgToast("success", "Your Password has been changed,Please sigin", 'top-right');
                } else {
                    msgToast("success", msg, 'top-right');
                }
                setTimeout(function () { navigate("/Signin") }, 1000);

            } else {
                msgToast("error", msg, 'top-right');
                return;
            }
        } catch (error) {
            msgToast("error", "An error occurred please try again", 'top-right');
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
    return (
        <div className="appMain">
            {loading && <Loader />}
            <Onboartop />
            <div className="container-fuild app-main-card onboard-card">
                <div className="container mx-width">
                    <h4 className="app-title">Update Passwrod</h4>
                </div>
                <div className="container p-0 mx-width">
                    <form method="POST" action="" onSubmit={handleSubmit} autoComplete="off" className="form-horizontal" id="frm_new">
                        <div className="container-fluid p-0">
                            <div className="row m-0">
                                <div className="col-12 mb-3">
                                    <div className="input-group">
                                        <span className="input-group-text"><BsShieldLock /></span>
                                        <input type="text" className="form-control" value={changePass.cust_otp_code} onChange={handleIpunt} placeholder="Verification code" name="cust_otp_code" />
                                    </div>
                                    {errors.cust_otp_code && <div className="invalid-feedback" style={{ display: "block" }}>{errors.cust_otp_code}</div>}
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="input-group">
                                        <span className="input-group-text"><BiLockAlt /></span>
                                        <input type={inputType} className="form-control" autoComplete="off" value={changePass.cust_login_pass} onChange={handleIpunt} placeholder="Password" id="cust_login_pass" name="cust_login_pass" />
                                    </div>
                                    {errors.cust_login_pass && <div className="invalid-feedback" style={{ display: "block" }}>{errors.cust_login_pass}</div>}
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="input-group">
                                        <button className="btn btn-primary btn-app">Update Password</button>
                                    </div>
                                </div>
                                <div className="col-12">
                                    {errors.app_error && <div className="alert alert-danger mb-3">{errors.app_error}</div>}
                                </div>
                                <div className="col-12">
                                    <div className="input-group mb-3">
                                        <Link to="/Forgetpass" className="w-100">
                                            <button type="button" className="btn btn-primary btn-app btn-app-active">Send again OTP</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {/* closing app-main-card */}
        </div>

    );
}

export default Setpassword;
